import { render, staticRenderFns } from "./KarmaCategoryList.vue?vue&type=template&id=0e9e2b10&scoped=true&"
import script from "./KarmaCategoryList.vue?vue&type=script&lang=js&"
export * from "./KarmaCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCategoryList.vue?vue&type=style&index=0&id=0e9e2b10&lang=scss&scoped=true&"
import style1 from "./KarmaCategoryList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e2b10",
  null
  
)

export default component.exports